































import {Vue, Component, Prop} from 'vue-property-decorator'
import {Action} from 'vuex-class'
import {PopupState} from '@/store'
import VehicleView from '@/views/Vehicle/Vehicle.vue'
import {VehicleSlot} from '@/lib/kepler/interfaces'
import ServiceMesh from '@/lib/serviceMesh'
import DateHelper from '@/lib/DateHelper'
import Utils from '@/utils'

@Component({
  components: {
    Container: Utils.loadComponent('proxy/Container'),
    Layout: Utils.loadComponent('proxy/Layout'),
    Flex: Utils.loadComponent('proxy/Flex'),
    Img: Utils.loadComponent('proxy/Image'),
    Chip: Utils.loadComponent('proxy/Chip'),
    Plate: Utils.loadComponent('Plate'),
    Divider: Utils.loadComponent('proxy/Divider'),
    FuelLevel: Utils.loadComponent('FuelLevel'),
    CustomIcon: Utils.loadComponent('CustomIcon'),
    VehicleTypeChip: Utils.loadComponent('entities/vehicle/VehicleTypeChip'),
  },
})
export default class VehicleCardPopup extends Vue {
  @Action('openPopup') public openPopup!: (payload: PopupState) => void
  @Action('setVehicleSlot') public setVehicleSlot!: (payload: VehicleSlot) => void

  @Prop({type: Object}) private vehicleSlot!: VehicleSlot

  public get fuelLevelImage() {
    return ServiceMesh.getImageForFuelLevel(this.vehicle)
  }

  public get priceCycle() {
    if (this.vehicleSlot.base_rate) {
      return DateHelper.parseMinutes(this, this.vehicleSlot.base_rate.time_rate.time_cost_cycle)
    }
  }

  public get typeKey() {
    return `${this.vehicleSlot.reservation_type}${this.vehicle.category.type}`.toUpperCase()
  }

  public get vehicle() {
    return this.vehicleSlot.vehicle
  }

  public get distanceString() {
    const d: number | null = this.vehicleSlot.distance
    let str: string | null = null
    if (d !== null) {
      str = `${this.$t('common.circa')} `
      str += d >= 1000 ? `${Math.round((d / 1000) * 10) / 10}Km` : `${Math.floor(d)}m`
    }
    return str
  }

  protected selected() {
    this.openPopup(new PopupState(VehicleView, {vehicleSlot: this.vehicleSlot}, this.$t('vehicle.vehicle_detail')))
  }
}
